.root {
  color: var(--x-color-text-secondary);
  font-size: 13px;
  font-style: inherit;
  word-break: break-all;
}

.italic {
  font-style: italic;
}

.secondary {
  color: var(--x-color-text-secondary-disabled);
}
